export default "__VITE_ASSET__B2xN5E4d__"